var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aboutUs"},[_c('div',{staticClass:"aboutUs__content titleh2 bmf"},[_c('p',[_vm._v("создаЁм для бизнеса и персоналий стратегии, эффективный и эффектный контент, PR, аудиоподкасты, продюсируем YouTube.")])]),_c('div',{staticClass:"noise"})])
}]

export { render, staticRenderFns }